<ng-container *ngIf="languages$ | async as languages">
  <div *ngIf="languages.length > 1" class="language-picker">
    <tui-select
      [formControl]="languageControl"
      class="language-picker-select"
      [valueContent]="selectedLanguage"
      [tuiTextfieldLabelOutside]="true"
    >
      <tui-data-list-wrapper
        *tuiDataList
        size="l"
        [itemContent]="content"
        [items]="languages"
      ></tui-data-list-wrapper>
    </tui-select>

    <ng-template #selectedLanguage let-value>
      <div class="selected-language">
        <span>{{ languageControl.value | uppercase }}</span>
        <img [src]="getCountryForLanguage(languageControl.value) | uppercase | tuiFlag" />
      </div>
    </ng-template>

    <ng-template #content let-lang>
      <span>{{ getLocaleCountryNameForLanguage(lang) | titlecase }}</span>
    </ng-template>
  </div>
</ng-container>
